import { takeEvery } from 'redux-saga/effects';

import actionTypes from '../../../actionTypes';

import {
	getAnomalyDetectionData,
	getAnomaliesSalesMetrics,
	getRootCausesData,
	getRootCauseMetricsData,
	getInventoryRootCauseData,
} from './graphqlSaga';
import { getStoreDrillDownData } from './storeDrillDownSaga';

export default function* guidedInsightsWatcher() {
	yield takeEvery(
		actionTypes.GET_ANOMALY_DETECTION_DATA,
		getAnomalyDetectionData
	);
	yield takeEvery(
		actionTypes.GET_ANOMALIES_SALES_METRICS,
		getAnomaliesSalesMetrics
	);
	yield takeEvery(actionTypes.GET_RCA_DATA, getRootCausesData);
	yield takeEvery(actionTypes.GET_RCA_BDD_METRICS, getRootCauseMetricsData);
	yield takeEvery(
		actionTypes.UPDATE_INVENTORY_ROOTCAUSE,
		getInventoryRootCauseData
	);
	yield takeEvery(actionTypes.GET_STORE_DRILL_DOWN_DATA, getStoreDrillDownData);
}
